// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__9G55H","actions":"GroupTable_actions__3Nr6_","deleteModalFooter":"GroupTable_deleteModalFooter__HOX3F"};